import { HttpContextToken } from "@angular/common/http";

export const SkipBy503TokenInterceptor = new HttpContextToken(() => true);
